
export type GetCoursesType = typeof GetCoursesType[keyof typeof GetCoursesType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCoursesType = {
  USER: 'USER',
  ENROLLED: 'ENROLLED',
  POPULAR: 'POPULAR',
  ROADMAP: 'ROADMAP',
  FORYOU: 'FORYOU',
  MY_PUBLISHED: 'MY_PUBLISHED',
} as const;
